/** DG — Design Gallery constants (TS portion) */

export const GALLERY_BASE = "/cake-gallery";

// Team's generic /api proxy targets the Manage backend, whose JWT contract is
// different from the TS JWT accepted by Gallery. Only the exact production
// Team host crosses to Manage's dedicated /api/gallery proxy; previews and
// staging hosts stay same-origin.
const PRODUCTION_TEAM_HOST = "team.thetabletop.in";
const PRODUCTION_GALLERY_API = "https://manage.thetabletop.in/api/gallery";

export function galleryApiForHostname(hostname = "") {
  return hostname === PRODUCTION_TEAM_HOST ? PRODUCTION_GALLERY_API : "/api/gallery";
}

const currentHostname = typeof window !== "undefined" ? window.location.hostname : "";
export const GALLERY_API = galleryApiForHostname(currentHostname);
export const NCA_PUBLIC_BASE = "https://manage.thetabletop.in/tt-bk-x7m2k9p4";

export const STORAGE_LAYOUT = "ttt_dg_layout";
export const STORAGE_CATEGORY = "ttt_dg_category";

export const BRAND = {
  peach: "#EBB3A9",
  brand: "#EE2677",
  mint: "#9ED3AB",
  cream: "#EEEBD0",
  rose: "#E87EA1",
  ink: "#2D2D2D",
  muted: "rgba(45,45,45,0.55)",
};

export const DECOR_LEVELS = [
  "Standard",
  "Basic",
  "Medium",
  "Intense",
  "Advanced",
  "Master",
];

export const OCCASIONS = [
  "FOR HER",
  "FOR HIM",
  "KIDS",
  "BABIES",
  "BABY SHOWER",
  "ANNIVERSARY",
  "WEDDING",
  "BRIDE TO BE",
  "CONGRATULATIONS",
  "CORPORATE",
  "FESTIVAL",
  "SENIORS",
  "BENTO",
  "CUPCAKES",
  "CHEESE CAKES",
];

/** Primary staff-facing chips (horizontal bar) */
export const PRIMARY_CHIPS = [
  { id: "__all__", label: "All" },
  { id: "__new__", label: "New" },
  { id: "__m_app__", label: "M App" },
  { id: "__liked__", label: "Liked" },
  { id: "occ:FOR HER", label: "For Her" },
  { id: "occ:FOR HIM", label: "For Him" },
  { id: "occ:BABIES", label: "For Babies" },
  { id: "rel:GIRLS", label: "For Girls" },
  { id: "rel:BOYS", label: "For Boys" },
];

export const PAGE_SIZE = 50;

export const CHIP_LABEL_OVERRIDES = {
  "__liked__": "Liked",
  "occ:FOR HER": "For Her",
  "occ:FOR HIM": "For Him",
  "occ:BABIES": "For Babies",
  "occ:KIDS": "Kids",
};
